// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_ListResponse — GET /subscriptions/admin-terms/list.
 * Also reused, with a single-element `rows`, as the response of save/activate.
 *
 * `languages` rides along with the rows for the same reason the channel
 * templates console sends its language list: so the form's selector is not a
 * second, drifting copy of a list that lives somewhere else. It comes from the
 * translations-service — the users wizard's list.
 *
 * THE MARKET LIST IS DELIBERATELY NOT HERE. Subscription markets already have
 * one owner, GET /subscriptions/admin/market-countries, which annotates the
 * locations-service countries with MarketPolicy's verdict and carries their
 * NAMES and currencies. Shipping bare ISO codes from here would be exactly the
 * second, poorer copy that endpoint exists to prevent — and it showed: the
 * market selector offered "BR" instead of "BR — Brasil".
 */
import type { SubscriptionTerms_TermRow } from './SubscriptionTerms_TermRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubscriptionTerms_ListResponseDados {
rows: SubscriptionTerms_TermRow[]
languages: string[]
}

export type SubscriptionTerms_ListResponse = ApiResponse<SubscriptionTerms_ListResponseDados>;

registerResponseContract('SubscriptionTerms_ListResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:             { type: 'number',  required: true },
      plan_id:        { type: 'number',  required: false },
      plano_nome:     { type: 'string',  required: false },
      titulo:         { type: 'string',  required: false },
      versao:         { type: 'string',  required: false },
      ativo:          { type: 'boolean', required: false },
      aceites:        { type: 'number',  required: false },
      deactivated_at: { type: 'string',  required: false },
      created_by:     { type: 'string',  required: false },
      created_at:     { type: 'string',  required: false },
      updated_at:     { type: 'string',  required: false },
      variants: {
        type: 'array',
        required: false,
        items: {
          id:             { type: 'number',  required: true },
          term_id:        { type: 'number',  required: false },
          language:       { type: 'string',  required: false },
          conteudo:       { type: 'string',  required: false },
          content_sha256: { type: 'string',  required: false },
          updated_by:     { type: 'string',  required: false },
          created_at:     { type: 'string',  required: false },
          updated_at:     { type: 'string',  required: false },
        },
      },
    },
  },
  languages: { type: 'array',   required: true },
})
